import { createMuiStyles } from '../../utils/mui';

export const googleMapLocationStyles = createMuiStyles({
  map: {
    bgcolor: 'grey.50',
    borderRadius: '0.25rem',
    'div[role=dialog]': {
      py: 1.5,
      px: 3,
      fontFamily: (theme) => theme.typography.fontFamily,
      fontWeight: 'Medium',
    },
    '.gm-err-title, .gm-err-message': {
      fontFamily: (theme) => theme.typography.fontFamily,
    },
  },
  mapError: {
    p: 2,
    textAlign: 'center',
    bgcolor: 'grey.50',
    borderRadius: '0.25rem',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '10rem',
  },
  locationField: {
    mb: 0.5,
    'input.gm-err-autocomplete': {
      backgroundImage: 'none!important',
    },
  },
});
